import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { ChangeWorkStationModalLayout } from '../ChangeWorkStationModalLayout'

class ChangeWorkStation extends Component {
    constructor() {
        super()
        this.state = {
            isImportChangeWorkStationModalOpened: false,
        }
    }
    openImportChangeWorkStationModal = () => {
        this.setState({ isImportChangeWorkStationModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isImportChangeWorkStationModalOpened: status })
    }

    refreshOrderList = () => {
        this.props.refreshOrderList()
    }

    render() {
        let modalComponent = null

        if (this.state.isImportChangeWorkStationModalOpened) {
            modalComponent =
                <HBBModal>
                    <ChangeWorkStationModalLayout data={this.props.data}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div style={{marginRight: "14px",float: "left"}}>
                {modalComponent}
                <button
                    className="btn btn-primary button-custom button-custom-edit button-kitchen-ws"
                     onClick={(e) => {
                        e.preventDefault()
                        this.openImportChangeWorkStationModal()
                    }}>
                    <i class="fa fa-building"></i> Change WS
                </button>
            </div>
        )
    }
}

export default ChangeWorkStation


// WEBPACK FOOTER //
// ./src/modules/Kitchens/Components/ActionButtons/ChangeWorkStation.js